import bitgeo from 'bitgeo';
import {apiSlice} from '../api/apiSlice';
import {byRecency} from '../util/mosaic';
import {createSelector} from '@reduxjs/toolkit';
import {modes} from '../actions/ui';

import kinda from 'kinda';

const getQuads = state => state.quads && state.quads.items;
const getBitbox = state => state.geometry && state.geometry.bitbox;
export const getFilteredQuads = createSelector(
  getQuads,
  getBitbox,
  (quads, bitbox) => {
    if (!bitbox) {
      return quads;
    }

    return quads.filter(quad => {
      const quadBits = quad.bbox.map(coord =>
        Math.floor(coord / bitbox.resolution)
      );
      return bitbox.contains(...quadBits) !== bitgeo.NONE;
    });
  }
);

const getActiveQuadId = state => state.activeQuad;
export const getActiveQuad = createSelector(
  getFilteredQuads,
  getActiveQuadId,
  (filteredQuads, activeQuadId) =>
    filteredQuads && filteredQuads.find(quad => quad.id === activeQuadId)
);

export const getSelectedQuadId = state => state.selectedQuad;
export const getSelectedQuad = createSelector(
  getFilteredQuads,
  getSelectedQuadId,
  (filteredQuads, selectedQuadId) =>
    filteredQuads && filteredQuads.find(quad => quad.id === selectedQuadId)
);

export const getFilteredName = state => state.filter.name;
export const getFilteredTypes = state => state.filter.types;

const selectMosaicsResult = apiSlice.endpoints.getMosaics.select();

export const selectMosaicsData = createSelector(
  selectMosaicsResult,
  mosaicsResult => mosaicsResult?.data ?? []
);

export const getFilteredMosaics = createSelector(
  [selectMosaicsData, getFilteredName, getFilteredTypes],
  (mosaics, nameFilter, typesFilter) => {
    return mosaics
      ?.map(mosaic => {
        if (!nameFilter) {
          return {score: 1, mosaic};
        }

        const terms = nameFilter.split(/\s+/);
        const total = terms.reduce((score, term) => {
          const nameScore = kinda(term, mosaic.name);
          const titleScore = kinda(term, mosaic.title);
          return score + Math.max(nameScore, titleScore);
        }, 0);
        return {
          score: total / terms.length,
          mosaic,
        };
      })
      .filter(item => item.score > 0.1)
      .filter(item => typesFilter[item.mosaic.type])
      .sort((a, b) => b.score - a.score || byRecency(a.mosaic, b.mosaic))
      .map(item => item.mosaic);
  }
);

const getSelectedMosaicName = state => state.mosaics.selected;

export const getSelectedMosaic = createSelector(
  getFilteredMosaics,
  getSelectedMosaicName,
  (mosaics, selected) => {
    let mosaic = null;
    if (selected) {
      mosaic = mosaics.find(mosaic => mosaic.name === selected);
    }
    if (!mosaic && mosaics.length > 0) {
      mosaic = mosaics[0];
    }
    return mosaic;
  }
);

const getComparingMosaicName = state =>
  state.ui.mode === modes.COMPARE ? state.mosaics.comparing : null;

export const getComparingMosaic = createSelector(
  selectMosaicsData,
  getComparingMosaicName,
  (mosaics, comparingMosaicName) =>
    mosaics.find(mosaic => mosaic.name === comparingMosaicName)
);
